import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { QRScannerService } from "src/app/shared/services/qr-scanner.service";

@Component({
    selector: 'app-qr-no-camera-access',
    templateUrl: './no-camera-access.component.html',
    standalone: false
})
export class NoCameraAccessComponent {

    constructor(private _modal: NgbActiveModal, private _qrScannerService: QRScannerService) {

    }

    public back() {
        this._modal.close();
        this._qrScannerService.onClose?.();
    }

    public async tryAgain() {
        this._qrScannerService.closeScanner();
        try {
            await this._qrScannerService.initialiseScanner(null);
            this._modal.close();
        } catch (e) {
            this._modal.close();
        }
    }


}